/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const Billing = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 30 30" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 3C10.4696 3 9.96086 3.21071 9.58579 3.58579C9.21071 3.96086 9 4.46957 9 5V7H7C6.46957 7 5.96086 7.21071 5.58579 7.58579C5.21071 7.96086 5 8.46957 5 9V27C5 27.5304 5.21071 28.0391 5.58579 28.4142C5.96086 28.7893 6.46957 29 7 29H21C21.5304 29 22.0391 28.7893 22.4142 28.4142C22.7893 28.0391 23 27.5304 23 27V25H25C25.5304 25 26.0391 24.7893 26.4142 24.4142C26.7893 24.0391 27 23.5304 27 23V9C27 8.73478 26.8946 8.48043 26.7071 8.29289L21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3H11ZM23 23H25V9.41421L20.5858 5L11 5V7H17C17.2652 7 17.5196 7.10536 17.7071 7.29289L22.7071 12.2929C22.8946 12.4804 23 12.7348 23 13V23ZM7 9L7 27H21V13.4142L16.5858 9H7Z"
        fill="#21295C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 19C10 18.4477 10.4477 18 11 18H17C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20H11C10.4477 20 10 19.5523 10 19Z"
        fill="#21295C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 23C10 22.4477 10.4477 22 11 22H17C17.5523 22 18 22.4477 18 23C18 23.5523 17.5523 24 17 24H11C10.4477 24 10 23.5523 10 23Z"
        fill="#21295C"
      />
    </BaseSvgIcon>
  )
}

export default Billing
